import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { OrderTemporaryRequestBody, OrderTemporaryResponse } from "./types";

export class OrderTemporaryAPI extends BaseAPI<
  OrderTemporaryRequestBody,
  OrderTemporaryResponse
> {
  protected route = ApiRoutes.order.temporary;
  protected method = RequestMethod.POST;
}
